"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _hasMultipleConditions = _interopRequireDefault(require("./hasMultipleConditions"));

var shouldDisplayLiteralProgression = function shouldDisplayLiteralProgression(_ref) {
  var _ref$conditions = _ref.conditions,
      conditions = _ref$conditions === void 0 ? {} : _ref$conditions,
      customObjective = _ref.customObjective;
  return !customObjective && !(0, _hasMultipleConditions["default"])({
    conditions: conditions
  }) && !conditions.repeat;
};

var _default = shouldDisplayLiteralProgression;
exports["default"] = _default;
//# sourceMappingURL=shouldDisplayLiteralProgression.js.map